module.exports = __webpack_public_path__ + "static/img/img-03.f425aa5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/slider/img-03.jpg
// module id = 80
// module chunks = 0